import type { ReactNode } from 'react';

import { DateHeure } from '../../composants/communs.tsx';
import { Icone } from '../../composants/icones.tsx';
import { Montant } from '../../composants/ui/index.ts';
import { libelleMode } from './modes.ts';
import type { DetailVente } from './types.ts';

/** Panneau règlement — total en bandeau, liste des paiements, solde. */
export function Reglement({ vente }: { vente: DetailVente }): ReactNode {
  return (
    <section aria-label="Règlement" className="fiche-reglement">
      <div className="fiche-reglement__bandeau">
        <div className="fiche-reglement__bandeau-libelle">Total de la vente</div>
        <div className="fiche-reglement__bandeau-valeur">
          <Montant valeur={vente.total} />
        </div>
      </div>

      <div className="fiche-reglement__corps pile" style={{ gap: 12 }}>
        <h2 style={{ margin: 0, fontSize: 'var(--taille-menu)' }}>Règlements</h2>

        {vente.paiements.length === 0 ? (
          <p className="table-vide">Aucun règlement : cette vente est entièrement à crédit.</p>
        ) : (
          vente.paiements.map((paiement) => (
            <div key={paiement.id} className="fiche-reglement-ligne">
              <span className="fiche-reglement-ligne__icone">
                <Icone nom="monnaie" taille={18} />
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{libelleMode(paiement.mode)}</div>
                <div className="entete__sous">
                  {paiement.reference_transaction === null || paiement.reference_transaction === undefined
                    ? 'Sans référence'
                    : `${paiement.operateur ?? ''} ${paiement.reference_transaction}`.trim()}
                  {' · '}
                  <DateHeure valeur={paiement.horodatage_local} />
                </div>
              </div>
              <span style={{ fontWeight: 700 }}>
                <Montant valeur={paiement.montant} />
              </span>
            </div>
          ))
        )}

        <div className="pile" style={{ gap: 6 }}>
          <div className="ligne" style={{ justifyContent: 'space-between' }}>
            <span>Encaissé</span>
            <span style={{ fontWeight: 600 }}>
              <Montant valeur={vente.encaisse} />
            </span>
          </div>
          <div className={`fiche-solde${vente.reste_du > 0 ? ' fiche-solde--du' : ''}`}>
            <span>{vente.reste_du > 0 ? 'Reste à payer' : 'Soldé'}</span>
            <span>
              <Montant valeur={vente.reste_du} />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
